import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const toggleAuditDetails = createAction('toggleAuditDetails');

const {
  setListLoading,
  setInitialState,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
} = getReportActions();

export {
  // report
  setListLoading,
  setInitialState,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  //
  toggleAuditDetails,
};
